import styled from 'styled-components';
import { Button } from '../../../components/utils/Button/Button';
import { Text14Bold } from '../../../components/utils/Text/Text.styles';

export const Container = styled.div`
  height: 100%;
  background: #f9fafb;
`;

export const StyledButton = styled(Button)`
  width: unset;
  height: 3.4rem;
  font-size: 1.4rem;
  padding-inline: 1.6rem;
  border-radius: 12px;
`;

export const LoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100% - 6.8rem);
`;

export const InfiniteScrollMarker = styled.div`
  height: 1rem;
`;

export const LoaderMoreContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ListContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto 1fr;
  gap: 0.3rem;
  padding: 0.3rem;
  height: calc(100% - 6.8rem);
  overflow: auto;
`;

export const BundleWrapper = styled.div`
  position: relative;
  height: 15rem;
  border-radius: 4px;
  border: 1px solid #f3f4f6;
  background: #fff;
  padding: 1.2rem 1.6rem;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  cursor: pointer;
`;

export const ImagesContainer = styled.div`
  display: flex;
  position: relative;
  width: 16.6rem;
  height: 6.4rem;
`;

export const ImageWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid #fff;
  height: 6.4rem;
  width: 6.4rem;
  overflow: hidden;
  left: ${({ $left }) => `${$left / 10}rem`};
  position: absolute;
  img {
    object-fit: cover;
  }
`;

export const NumberOfMediaContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #fff;
  background: #daedff;
  height: 6.4rem;
  width: 6.4rem;
  display: flex;
  left: ${({ $left }) => `${$left / 10}rem`};
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    color: #1672ba;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  gap: 0.8rem;
  align-items: center;
`;

export const Title = styled(Text14Bold)`
  color: #1672ba;
`;
